// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import InteractivePopoverController from "./interactive_popover_controller"
application.register("interactive-popover", InteractivePopoverController)

import SearchableSelectController from "./searchable_select_controller"
application.register("searchable-select", SearchableSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DebounceController from "./debounce_controller"
application.register("debounce", DebounceController)

import RowLinkController from "./row_link_controller"
application.register("row-link", RowLinkController)

import VinLookupController from "./vin_lookup_controller"
application.register("vin-lookup", VinLookupController)

import BatchSelectionController from "./batch_selection_controller"
application.register("batch-selection", BatchSelectionController)

import AddToSaleController from "./add_to_sale_controller"
application.register("add-to-sale", AddToSaleController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import FileDropController from "./file_drop_controller"
application.register("file-drop", FileDropController)

import VinSearchController from "./vin_search_controller"
application.register("vin-search", VinSearchController)

import DocumentUploadController from "./document_upload_controller"
application.register("document-upload", DocumentUploadController)

import DocumentSplitController from "./document_split_controller"
application.register("document-split", DocumentSplitController)

import PdfZoomController from "./pdf_zoom_controller"
application.register("pdf-zoom", PdfZoomController)

import PhotoSortController from "./photo_sort_controller"
application.register("photo-sort", PhotoSortController)

import NumericInputController from "./numeric_input_controller"
application.register("numeric-input", NumericInputController)

import AddressPrefillController from "./address_prefill_controller"
application.register("address-prefill", AddressPrefillController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DateInputController from "./date_input_controller"
application.register("date-input", DateInputController)

import SaveStatusController from "./save_status_controller"
application.register("save-status", SaveStatusController)

import FrameMorphController from "./frame_morph_controller"
application.register("frame-morph", FrameMorphController)

import GridController from "./grid_controller"
application.register("grid", GridController)

import GridAutosaveController from "./grid_autosave_controller"
application.register("grid-autosave", GridAutosaveController)

import NestedForm from "@stimulus-components/rails-nested-form"
application.register("nested-form", NestedForm)

import ContactSelectController from "./contact_select_controller"
application.register("contact-select", ContactSelectController)

import NotificationReadController from "./notification_read_controller"
application.register("notification-read", NotificationReadController)

import CommentComposerController from "./comment_composer_controller"
application.register("comment-composer", CommentComposerController)

import CommentReadController from "./comment_read_controller"
application.register("comment-read", CommentReadController)

import UserRoleController from "./user_role_controller"
application.register("user-role", UserRoleController)

import SubmissionChecklistController from "./submission_checklist_controller"
application.register("submission-checklist", SubmissionChecklistController)

import SigningDocumentController from "./signing_document_controller"
application.register("signing-document", SigningDocumentController)

import SigningReviewController from "./signing_review_controller"
application.register("signing-review", SigningReviewController)

import SigningPlacementController from "./signing_placement_controller"
application.register("signing-placement", SigningPlacementController)

import HandwritingPreviewController from "./handwriting_preview_controller"
application.register("handwriting-preview", HandwritingPreviewController)

import ExpenseBatchEditController from "./expense_batch_edit_controller"
application.register("expense-batch-edit", ExpenseBatchEditController)
